import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Save } from "lucide-react";

export const CHART_COLORS = ["#ff6b35", "#ffb703", "#00e5ff", "#00ff88", "#a3a3a3", "#f472b6"];

export const tooltipStyle = {
    contentStyle: { background: "#12141d", border: "1px solid #2a2e3d", borderRadius: 8, fontFamily: "JetBrains Mono, monospace", fontSize: 12 },
    labelStyle: { color: "#f1f5f9" },
    itemStyle: { color: "#f1f5f9" },
};

export function Card({ title, icon: Icon, accent = "text-ares-orange", children, testid, className = "" }) {
    return (
        <div className={`rounded-xl border border-ares-border bg-ares-dark/90 p-5 ${className}`} data-testid={testid}>
            {title && (
                <div className="flex items-center gap-2 mb-4">
                    {Icon && <Icon className={`w-4 h-4 ${accent}`} />}
                    <h3 className="font-mono text-[11px] uppercase tracking-widest text-ares-muted">{title}</h3>
                </div>
            )}
            {children}
        </div>
    );
}

export function Stat({ label, value, unit, testid }) {
    return (
        <div className="rounded-lg border border-ares-border bg-ares-panel/60 px-3 py-2.5" data-testid={testid}>
            <p className="font-mono text-[10px] uppercase tracking-widest text-ares-muted">{label}</p>
            <p className="font-heading text-lg font-semibold text-ares-bright mt-0.5">
                {value}<span className="text-xs text-ares-muted font-mono ml-1">{unit}</span>
            </p>
        </div>
    );
}

export function SaveFinding({ text, featureType }) {
    const [projects, setProjects] = useState([]);
    const [pid, setPid] = useState("");

    useEffect(() => {
        api.get("/projects").then(({ data }) => setProjects(data)).catch(() => {});
    }, []);

    const save = async () => {
        try {
            await api.post(`/projects/${pid}/findings`, { text, feature_type: featureType });
            toast.success("Saved to project workspace");
        } catch (e) {
            toast.error("Could not save finding");
        }
    };

    if (!projects.length) return <p className="text-xs text-ares-muted" data-testid="ground-save-no-projects">Create a project in Project Workspace to save findings.</p>;
    return (
        <div className="flex gap-2">
            <Select value={pid} onValueChange={setPid}>
                <SelectTrigger className="bg-ares-panel border-ares-border flex-1 h-9" data-testid="ground-save-project-select">
                    <SelectValue placeholder="Save summary to project…" />
                </SelectTrigger>
                <SelectContent className="bg-ares-panel border-ares-border">
                    {projects.map((p) => <SelectItem key={p.id} value={p.id}>{p.name}</SelectItem>)}
                </SelectContent>
            </Select>
            <Button onClick={save} disabled={!pid} className="h-9 bg-ares-orange hover:bg-[#e55a2b] text-white" data-testid="ground-save-finding-btn">
                <Save className="w-4 h-4" />
            </Button>
        </div>
    );
}
